import { useEffect, useState, useMemo } from "react";
import API from "../../services/API/CRM";
import Layout from '../Frames/Layout'
import { Link } from "react-router-dom";
import { Link as A, Button, IconButton } from "@mui/material";
import Grid from "../Tools/Grid";
import Flex from "../Tools/Flex";
import Search from '../Inputs/Search'
import useJsonStore from "../../services/Hooks/useJsonStore";
import { Delete } from "@mui/icons-material";
import Avatar from "../Tools/Avatar";

export default function Prospects(){
    
    const columns = [
        {
            field: 'avatar',
            headerName: 'Fiche',
            width: 60,
            valueGetter: p => p.row.initials,
            renderCell: p => <Link to={`/crm/prospects/${p.id}`}>
                <Avatar 
                    initials={p.row.initials} 
                    color={p.row.category?.color || 'grey'} 
                    size={36} 
                />
            </Link>,
        },
        {
            field: 'firstName',
            headerName: 'Prénom',
            width: 150,
            valueGetter: p => p.row.firstName
        },
        {
            field: 'lastName',
            headerName: 'Nom',
            width: 150,
            valueGetter: p => p.row.lastName
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            valueGetter: p => p.row.email,
            renderCell: p => <A href={`mailto:${p.row.email}`}>{p.row.email}</A>,
        },
        {
            field: 'phone',
            headerName: 'Téléphone',
            width: 160,
            valueGetter: p => p.row.phone,
            renderCell: p => <A href={`tel:${p.row.phone}`}>{p.row.phone}</A>
        },
        {
            field: 'origin',
            headerName: 'Provenance',
            width: 150,
            valueGetter: p => p.row.origin?.title,
        },
        {
            field: 'motive',
            headerName: 'Motif du contact',
            width: 200,
            valueGetter: p => p.row.motive,
        },
        {
            field: 'course',
            headerName: 'Formation',
            width: 200,
            valueGetter: p => p.row.course?.title,
        },
        {
            field: 'createdBy',
            headerName: 'Créé par',
            width: 150,
            valueGetter: p => p.row.createdBy?.name,
        },
        {
            field: 'createdAt',
            headerName: 'Créé le',
            width: 120,
            type: 'date',
            renderCell: p => p.value.toLocaleDateString(),
            valueGetter: p => new Date(p.row.createdAt.replace(' ', 'T'))
        },
        {
            field: 'delete',
            headerName: '',
            width: 50,
            valueGetter: p => p.row.id,
            renderCell: p => <IconButton size='small' onClick={() => handleDelete(p.row.id)}>
                <Delete />
            </IconButton>
        },
    ];

    const [items, setItems] = useState(null)
    const [search, setSearch] = useState('')
    const store = useJsonStore();

    useEffect(() => {

        const search = store.get('prospectSearch') || '';

        setSearch(search)

        API.getProspects()
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }, [store])


    const rows = useMemo(() => {

        const match = p => (p.name + p.phone + p.email).toLowerCase().includes(search.toLowerCase())

        return items ? items.filter(p => match(p)) : null

    }, [items, search])


    const handleSearch = e => {
        const v = e.target.value;
        store.set('prospectSearch', v);
        setSearch(v);
    }

    const handleDelete = id => {

        if( !window.confirm("Êtes-vous sûr de vouloir supprimer ce prospect ?") ){
            return false;
        }

        const old = [...items];
        let copy = [...items];
        copy = copy.filter(i => i.id !== id);
        setItems(copy)

        API.deleteProspect(id).catch(e => setItems(old))
    }



    return <Layout tab='prospects' menu='crm' title='Prospects'>

        <Flex justifyContent='space-between' alignItems='center' sx={{mb: 1}}>

            <Search
                value={search}
                onChange={handleSearch}
            />

            <Link to='/crm/prospects/new'>
                <Button variant='contained'>Ajouter</Button>
            </Link>

        </Flex>

        <Grid 
            id='prospectsGrid'
            columns={columns}
            rows={rows}
            toolbar
        />

    </Layout>

}


